import HomeIcon from "@material-ui/icons/Home";
import CameraAltIcon from "@material-ui/icons/CameraAlt";

import { Home, Viewer } from "./pages";

export default {
  items: [
    {
      path: "/home",
      name: "撮影",
      key: "home",
      type: "link",
      icon: CameraAltIcon,
      component: Home,
      sideBar: true,
    },
    {
      path: "/viewer/:pid",
      name: "ビューワー",
      key: "view",
      type: "link",
      icon: HomeIcon,
      component: Viewer,
      sideBar: false,
    },
  ],
};
